import { Component , OnInit, ViewChild } from '@angular/core';
import { SidebarService } from '../sidebar/sidebar.service';
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe } from '@angular/common';
import { RequestService } from 'src/services/request.service';
import { DataTableDirective} from 'angular-datatables';
import {Subject} from 'rxjs';
import {map} from 'jquery';
import html2canvas from 'html2canvas';

export var globalEmpId: number = 0;
export var globalVehicleId: any = "";
export var globalDocumentName: any = "";
export var globalExpiryDate: number = 0;
export var globalDays: number = 0;
export var globalIsSeen: any = "";

export var globalLastLat: any = new Map();
export var globalLastLng: any = new Map();

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit{
    @ViewChild(DataTableDirective, {static: false})
	dtElement: DataTableDirective;
    dtOptions: any={};
	// dtOptions: DataTables.Settings = {};
	dtTrigger: Subject<any> = new Subject();

    constructor(
        public sidebarservice: SidebarService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public datePipe: DatePipe,
        public request: RequestService
        ) { }
        
    toggleSidebar() {
        this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());
        
        if ($("#wrapper").hasClass("nav-collapsed")) {
            // unpin sidebar when hovered
            $("#wrapper").removeClass("nav-collapsed");
            $("#sidebar-wrapper").unbind( "hover");
        } else {
            $("#wrapper").addClass("nav-collapsed");
            $("#sidebar-wrapper").hover(
                function () {
                    $("#wrapper").addClass("sidebar-hovered");
                },
                function () {
                    $("#wrapper").removeClass("sidebar-hovered");
                }
            )
        }
    }
    
    getSideBarState() {
        return this.sidebarservice.getSidebarState();
    }

    hideSidebar() {
        this.sidebarservice.setSidebarState(true);
    }

    showAndHideToggleIcon(type){
        if(type==true){
            $("#toggle_menu_icon").hide();
        }else{
            $("#toggle_menu_icon").show();
        }
    }

    fullName;
    email;
    employeeId;
    roleId;
    ngOnInit() {
        globalEmpId=0;
        globalVehicleId="";
        globalDocumentName="";
        globalExpiryDate=0;
        globalDays=0;
        globalIsSeen="";
        this.ViewDate();
        this.ShowVehicleServiceNotifications();
        this.ShowNotifications();
        this.viewEmployeeByDob();
        this.ShowBlackoutNotifications();
        // alert(localStorage.getItem('roleId'));
        this.roleId = localStorage.getItem('roleId');
        this.fullName = localStorage.getItem('full_name');
        this.email = localStorage.getItem('email');
        this.employeeId = localStorage.getItem('employeeId');
        /* Search Bar */
        $(document).ready(function () {
            $(".search-btn-mobile").on("click", function () {
                $(".search-bar").addClass("full-search-bar");
            });
            $(".search-arrow-back").on("click", function () {
                $(".search-bar").removeClass("full-search-bar");
            });
        });

    }

    currentDate;
    nextDate1;
    nextDate2;
    ViewDate(){
        this.currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        this.currentDate;
        this.nextDate1 = new Date();
        this.nextDate1.setDate( this.nextDate1.getDate()+7);
        this.nextDate2 = this.datePipe.transform(this.nextDate1, 'yyyy-MM-dd');
    }

    documentExpiryAlertDetails=[];
    popupRowData;
    async GoToDocumentExpiryAlertReport(employeeId,vehicleId,documentName,expiryDate,days,isSeen){
        // alert(employeeId+" :: "+vehicleId+" >> "+this.router.url);
        // if(employeeId>0){
        //     globalEmpId=employeeId;
        //     globalVehicleId="";
        // }else{
        //     globalEmpId=0;
        //     globalVehicleId=vehicleId;
        // }
        // globalDocumentName=documentName;
        // globalExpiryDate=expiryDate;
        // globalDays=days;
        // globalIsSeen=isSeen;
        // let urlString = "notification";
        // this.router.navigate(['/form/document-expiry-alert/',urlString]);

        try {
            // alert(" >> "+this.currentDate+" :: "+this.nextDate2);
            this.documentExpiryAlertDetails=[];
            let sFromDate = this.currentDate+" 00:00:00";
            let sToDate =   this.nextDate2+ " 23:59:59";
            const alerts = {
              'fromDate' : this.datePipe.transform(sFromDate, 'yyyy-MM-dd HH:mm:ss'),
              'toDate' : this.datePipe.transform(sToDate, 'yyyy-MM-dd HH:mm:ss'),
              'employeeId':employeeId,
              'vehicleId':vehicleId,
              'documentName':documentName,
              'days':days
              };
              //console.log(alerts);
            const data: any = await this.request.post('/services/view_document_expiry_alerts/',alerts);
            //alert(data);  
            for (let objKey of Object.keys(data)) {
              let dataObj = data[objKey];
              if(objKey=="result"){
                for (let objKey1 of Object.keys(dataObj)) {
                  this.documentExpiryAlertDetails.push(dataObj[objKey1]);
                } 
              }				
            }
            this.popupRowData = this.documentExpiryAlertDetails;
            if(isSeen=="isSeen"){
              this.UpdateDocumentExpiryAlert(employeeId,vehicleId,documentName,days,expiryDate);
            }
          } catch (error) {}
    }

    UpdateAndShowNotification(){
        this.ShowNotifications();
    }

    username;
    isUpdatedRecord;
    async UpdateDocumentExpiryAlert(employeeId,vehicleId,documentName,days,expiryDate){
        // alert(employeeId+" :: "+vehicleId+" :: "+documentName+" :: "+days+" :: "+expiryDate);
        this.username = localStorage.getItem('email');
        try {
        const alerts = {
            'employeeId':employeeId,
            'vehicleId':vehicleId,
            'documentName':documentName,
            'days':days,
            'expiryDate':expiryDate,
            'seenUsername':this.username
        };
        const save: any = await this.request.post('/services/update_document_expiry_alerts',alerts);
        
        } catch (error) {}
    }

    totalNotification=0;
    async ShowVehicleServiceNotifications(){
        let currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        let sFromDate = currentDate+" 00:00:00";
        let sToDate = currentDate+" 23:59:59";
        try {
            const alerts = {
              'fromDate' : this.datePipe.transform(sFromDate, 'yyyy-MM-dd HH:mm:ss'),
              'toDate' : this.datePipe.transform(sToDate, 'yyyy-MM-dd HH:mm:ss'),
            };
            const data: any = await this.request.post('/services/view_service_alerts/',alerts);
            for (let objKey of Object.keys(data)) {
              let dataObj = data[objKey];
              if(objKey=="result"){
                for (let objKey1 of Object.keys(dataObj)) {
                    this.totalNotification++;
                    this.documentExpiryAlertsDetails.push(dataObj[objKey1]);
                } 
              }				
            }
         } catch (error) {}
    }

    totalBlackoutNotification=0;
    blackOutDetails=[];
    blackoutRowData;
    async ShowBlackoutNotifications(){
        this.totalBlackoutNotification=0;
        this.blackOutDetails=[];
        let currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        let sFromDate = currentDate+" 00:00:00";
        let sToDate = currentDate+" 23:59:59";
        try {
            const alerts = {
              'fromDate' : this.datePipe.transform(sFromDate, 'yyyy-MM-dd HH:mm:ss'),
              'toDate' : this.datePipe.transform(sToDate, 'yyyy-MM-dd HH:mm:ss'),
            };
            const data: any = await this.request.post('/hrms/view_employee_working_status/',alerts);
            for (let objKey of Object.keys(data)) {
              let dataObj = data[objKey];
              if(objKey=="result"){
                for (let objKey1 of Object.keys(dataObj)) {
                    this.totalBlackoutNotification++;
                    this.blackOutDetails.push(dataObj[objKey1]);
                } 
              }				
            }
            this.blackoutRowData = this.blackOutDetails;
         } catch (error) {}
    }

    nextDate;
    documentExpiryAlertsDetails=[];
    rowData;
    async ShowNotifications(){
        this.nextDate = new Date();
        this.nextDate.setDate( this.nextDate.getDate()+7);

        let sFromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        sFromDate = sFromDate+" 00:00:00";

        let sToDate = this.datePipe.transform(this.nextDate, 'yyyy-MM-dd');
        sToDate = sToDate+" 23:59:59";
       // console.log(sFromDate+" :: "+sToDate);
        try {
            const alerts = {
              'fromDate' : this.datePipe.transform(sFromDate, 'yyyy-MM-dd HH:mm:ss'),
              'toDate' : this.datePipe.transform(sToDate, 'yyyy-MM-dd HH:mm:ss'),
              'employeeId':0,
              'vehicleId':""
            };
            const data: any = await this.request.post('/services/view_document_expiry_alerts/',alerts);
            // this.documentExpiryAlertsDetails=[];
            for (let objKey of Object.keys(data)) {
              let dataObj = data[objKey];
              if(objKey=="result"){
                for (let objKey1 of Object.keys(dataObj)) {
                    if(dataObj[objKey1].isSeen=="false"){
                        this.totalNotification++;
                    }
                    this.documentExpiryAlertsDetails.push(dataObj[objKey1]);
                } 
              }				
            }
            this.rowData = this.documentExpiryAlertsDetails;
           // console.log(this.rowData);
         } catch (error) {}
    }
    
    
  totalBirthdayNotification=0;
  empDobDetails=[];
  birthdayRowData;
  async viewEmployeeByDob(){
    try {
    this.totalBirthdayNotification=0;
      this.empDobDetails=[];
        const employee = {
        'employeeId': 0
        };
      // this.dtTrigger=new Subject<any>();
		const data: any = await this.request.post('/hrms/view_employee/',employee);
      // this.dtTrigger.next();
        let dob;
        for (let objKey of Object.keys(data)) {
            let dataObj = data[objKey];
            if(objKey=="result"){
                for (let objKey1 of Object.keys(dataObj)) {
                    dob=new Date(Number(dataObj[objKey1].dob)).toLocaleDateString("en-us");
                    dataObj[objKey1].dob = this.datePipe.transform(dob, 'dd-MM-yyyy');
                    // console.log(this.datePipe.transform(dob, 'dd-MM')+" :: "+this.datePipe.transform(new Date(), 'dd-MM'));
                    // let tommorrow1 = new Date();
                    // tommorrow1.setDate(tommorrow1.getDate() + 1);
                    // let tommorrow2 = new Date();
                    // tommorrow2.setDate(tommorrow2.getDate() + 2);
                    //console.log(tommorrow1+" :: "+tommorrow2);
                    // if(((this.datePipe.transform(dob, 'dd-MM')==this.datePipe.transform(new Date(), 'dd-MM') || this.datePipe.transform(dob, 'dd-MM')==this.datePipe.transform(tommorrow1, 'dd-MM')) || this.datePipe.transform(dob, 'dd-MM')==this.datePipe.transform(tommorrow2, 'dd-MM'))){
                        if(this.datePipe.transform(dob, 'dd-MM')==this.datePipe.transform(new Date(), 'dd-MM')){
                        if(dataObj[objKey1].activeStatus=="active"){
                            this. totalBirthdayNotification++;
                            this.empDobDetails.push(dataObj[objKey1]);    
                        }
                    }
                }
            } 
        }				
      this.birthdayRowData = this.empDobDetails;
      //console.log(this.birthdayRowData);
     // this.rerender();
		} catch (error) {}
  }


    serviceData;
    serviceDataArr=[];
    GoToServiceAlertReport(alert){
        this.serviceDataArr=[];
        this.serviceDataArr.push(alert);
        this.serviceData = this.serviceDataArr;
    }

    boDataArr=[];
    boRowData;
    GoToBlackoutAlertReport(boData){
        this.boDataArr=[];
        this.boDataArr.push(boData);
        this.boRowData = this.boDataArr;
    }

    bdDataArr=[];
    bdRowData;
    birthDayEmployeeName="";
    GoToBirthdayAlertReport(bdData){
        this.bdDataArr=[];
        this.bdDataArr.push(bdData);
        this.bdRowData = this.bdDataArr;
        //console.log(bdData);
        if(bdData.designationName[0]=="DRIVER" || bdData.designationName[0]=="CONDUCTOR"){
            this.birthDayEmployeeName = "MR. "+bdData.firstName+" "+bdData.lastName;
        }else{
            this.birthDayEmployeeName = bdData.firstName+" "+bdData.lastName
        }
        $("#birthdayEmployeeName").text(this.birthDayEmployeeName);
        $("#birthdayDesignation").text(bdData.designationName[0]);

    }

    downloadURI(uri, name) {
        let link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        // window.location.reload();
    }

    DownloadAsImage() {
        let element = $(".frame")[0];
        html2canvas(element).then((canvas: any) => {
            let myImage = canvas.toDataURL();
            this.downloadURI(myImage, $("#birthdayEmployeeName").text()+".png");
        });
    }

    logout(){
        // alert("here");
        localStorage.clear();
    }

}
